import { Skeleton } from '@/_config/lib/react-native-skeleton';
import styles from './motoboy-details.module.scss';

export const MotoboyDetailsSkeleton = () => {
  return (
    <div className={styles.skeletonContainer}>
      <div className={styles.header}>
        <Skeleton height={34} borderRadius={8} width="10vw" />
        <Skeleton height={34} borderRadius={8} width="40vw" />
      </div>
      <div className={styles.balanceContainer}>
        <Skeleton height={17} borderRadius={8} width="15vw" />
      </div>
      <div className={styles.detailsContainer}>
        <div className={styles.details}>
          <Skeleton height={19} borderRadius={8} width="10vw" />
          <div />
          <Skeleton height={18} borderRadius={8} width="35vw" />
          <Skeleton height={18} borderRadius={8} width="31vw" />
          <Skeleton height={18} borderRadius={8} width="35vw" />
          <Skeleton height={18} borderRadius={8} width="30vw" />
          <Skeleton height={18} borderRadius={8} width="29vw" />
          <Skeleton height={18} borderRadius={8} width="35vw" />
          <Skeleton height={18} borderRadius={8} width="32vw" />
          <Skeleton height={18} borderRadius={8} width="35vw" />
          <Skeleton height={18} borderRadius={8} width="31vw" />
          <Skeleton height={18} borderRadius={8} width="33vw" />
          <Skeleton height={18} borderRadius={8} width="31vw" />
          <Skeleton height={18} borderRadius={8} width="30vw" />
          <Skeleton height={18} borderRadius={8} width="34vw" />
          <Skeleton height={18} borderRadius={8} width="29vw" />
          <Skeleton height={18} borderRadius={8} width="31vw" />
        </div>
        <div className={styles.details}>
          <Skeleton height={19} borderRadius={8} width="6vw" />
          <div />
          <div className={styles.bankContainer}>
            <Skeleton height={37} width="15vw" borderRadius={16} />
            <Skeleton height={37} width="15vw" borderRadius={16} />
          </div>
          <div />
          <Skeleton height={19} borderRadius={8} width="6vw" />
          <div />
          <div className={styles.bankContainer}>
            <Skeleton height={200} width="35vw" borderRadius={16} />
          </div>
          {/* <Skeleton height={18} width="35vw" />
          <Skeleton height={18} width="31vw" />
          <Skeleton height={18} width="35vw" />
          <Skeleton height={18} width="30vw" />
          <Skeleton height={18} width="29vw" />
          <Skeleton height={18} width="35vw" />
          <Skeleton height={18} width="32vw" />
          <Skeleton height={18} width="37vw" /> */}
        </div>
      </div>
    </div>
  );
};
